import Icon from '../components/Icon.vue'

Icon.register({
  glasses: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M574.1 280.4c1.3 5.1 1.9 10.3 1.9 15.5v70.3c0 62.9-51.6 113.9-115.2 113.9h-37.1c-60.3 0-110.4-45.9-114.9-105.4l-2.9-38.6h-35.8l-2.9 38.6c-4.5 59.4-54.6 105.4-114.9 105.4h-37.1c-63.6 0-115.2-51-115.2-113.9v-70.3c0-4.3 0.9-11.3 1.9-15.5l45.3-181.7c5.9-23.7 21.6-44 43-55.8 21.4-11.7 47-14.1 70.2-6.3l15.3 5.1c8.4 2.8 12.9 11.9 10.1 20.2l-5.1 15.2c-2.8 8.4-11.9 12.9-20.2 10.1l-13.2-4.4c-10.9-3.6-23-3.6-33.1 1.7-10.3 5.4-17.6 14.6-20.4 25.8l-38.5 153.8c22.2-6.8 49.8-12.5 81.2-12.5 34.8 0 74 7 114.9 26.8h73.2c40.9-19.7 80.1-26.7 114.9-26.7 31.4 0 59 5.6 81.2 12.5l-38.5-153.8c-2.8-11.3-10.1-20.5-20.4-25.8-10.2-5.3-22.3-5.4-33.2-1.7l-13.2 4.4c-8.4 2.8-17.4-1.7-20.2-10.1l-5.1-15.2c-2.8-8.4 1.7-17.5 10.1-20.2l15.3-5.1c23.2-7.8 48.8-5.4 70.2 6.3 21.4 11.8 37.1 32.1 43 55.8zM203.4 369.8l3.1-41.2c-22.7-8.6-46.1-12.9-69.9-12.9-29.2 0-54.5 6.4-72.6 12.9v37.5c0 27.5 23 49.9 51.2 49.9h37.1c26.7 0 49.1-20.3 51.1-46.2zM512 366.1l0-37.5c-18.1-6.5-43.4-12.9-72.5-12.9-23.9 0-47.3 4.3-70 12.9l3.1 41.2c2 25.9 24.4 46.2 51.1 46.2h37.1c28.2 0 51.2-22.4 51.2-49.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/glasses.js
// module id = 1390
// module chunks = 0